export default "__VITE_ASSET__b096bd0a__"